// BlogDetail.jsx
import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function BlogDetail() {
  const { id } = useParams();
  const [comment, setComment] = useState("");
  const [cname, setCname] = useState("");
  const [cemail, setCemail] = useState("");
  const [cwebsite, setCwebsite] = useState("");
  const [saveInfo, setSaveInfo] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);

  const [post, setPost] = useState([]);
  const getBlogData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/blog/${id}`);
      if (res.status === 200) {
        setPost(res.data.data);
        if (res.data.data?.pdf) {
          setPdfPreviewUrl(`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/blog/${res.data.data.pdf}`);
        }
      } else {
        setPost([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getBlogData();
  }, [id]);


  return (
    <>
      <style>{`
        :root{
          --bg: #f1f8fb;
          --card: #fff;
          --muted: #94a3b8;
          --accent: #06b6a4;
          --text: #0f1724;
          --border-soft: rgba(15,23,42,0.06);
        }

        .blog-wrapper{
          background: var(--bg);
          padding: 40px 0;
        }

        .post-card{
          background: var(--card);
          padding: 28px;
          border-radius: 12px;
          border: 1px solid var(--border-soft);
          box-shadow: 0 16px 40px rgba(7,20,25,0.06);
        }

        .post-title{
          font-size: 30px;
          font-weight: 800;
          color: var(--text);
        }

        .post-meta{
          display: flex;
          gap: 8px;
          color: var(--muted);
          font-size: 14px;
          margin-bottom: 16px;
        }

        .post-image{
          max-width: 100%;
          max-height: 380px;
          overflow: hidden;
          border-radius: 12px;
          margin-bottom: 24px;
          background: #f8fafc;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .post-image img{
          width: 100%;
          max-height: 380px;
          object-fit: contain;
          border-radius: 12px;
          display: block;
        }

        .post-content p{
          color: #333;
          line-height: 1.8;
          margin-bottom: 16px;
        }

        .tag{
          background: #e6fffa;
          color: var(--accent);
          padding: 6px 14px;
          border-radius: 20px;
          margin-right: 8px;
          font-size: 13px;
          font-weight: 600;
          display: inline-block;
          border: 1px solid rgba(6,182,164,0.15);
        }

        .sidebar-box{
          background: var(--card);
          padding: 18px;
          border-radius: 10px;
          border: 1px solid var(--border-soft);
          box-shadow: 0 10px 30px rgba(7,20,25,0.05);
          margin-bottom: 20px;
        }

        .avatar{
          width: 60px;
          height: 60px;
          background: #d1f3ee;
          border-radius: 50%;
          display:flex;
          justify-content:center;
          align-items:center;
          font-weight:bold;
          color:#0d9488;
        }

        .form-control{
          margin-bottom: 10px;
          border-radius: 8px;
        }

        .btn-send{
          background: linear-gradient(90deg,#06b6a4,#06d1c6);
          border: none;
          width: 100%;
          padding: 10px;
          color: #fff;
          font-weight: 700;
          border-radius: 10px;
        }

        /* PDF Viewer - professional card style */
        .pdf-viewer-card{
          margin-top: 28px;
          border: 1px solid var(--border-soft);
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(7,20,25,0.08);
          background: #fff;
        }
        .pdf-viewer-header{
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px;
          background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
          border-bottom: 1px solid #99f6e4;
        }
        .pdf-viewer-header h6{
          margin: 0;
          font-weight: 700;
          color: #0d9488;
          font-size: 15px;
        }
        .pdf-viewer-header .pdf-actions{
          display: flex;
          gap: 10px;
        }
        .pdf-viewer-header .pdf-actions a{
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 8px 14px;
          background: #0d9488;
          color: #fff;
          border-radius: 8px;
          text-decoration: none;
          font-size: 13px;
          font-weight: 600;
          transition: background 0.2s;
        }
        .pdf-viewer-header .pdf-actions a:hover{
          background: #0f766e;
          color: #fff;
        }
        .pdf-viewer-body{
          padding: 0;
          min-height: 480px;
        }
        .pdf-viewer-body iframe{
          width: 100%;
          height: 520px;
          border: none;
          display: block;
        }

        /* Mobile Fix */
        @media (max-width:991px){
          .post-title{ font-size: 24px; }
          .post-image, .post-image img{ max-height: 280px; }
          .pdf-viewer-body iframe{ height: 400px; }
        }
      `}</style>

      <div className="blog-wrapper">
        <div className="container">
          {/* BOOTSTRAP ROW */}
          <div className="row">
            {/* LEFT SIDE — col-9 */}
            <div className="col-lg-9 col-md-12 mb-4">
              <div className="post-card">
                <div
                  className="breadcrumb mb-2"
                  style={{ fontSize: "14px", color: "#6b7280" }}
                >
                  <Link to="/">Home</Link> / <Link to="/blog">Blog</Link> / Post
                </div>

                <h2 className="mt-1">{post.title}</h2>

                <div className="post-meta">
                  <span>{post?.date?.split("T")[0] || ""}</span>
                </div>

                {post.photo && (
                  <div className="post-image">
                    <img src={`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/blog/${post.photo}`} alt={post.title} />
                  </div>
                )}

                <p>{post.description}</p>

                {pdfPreviewUrl && (
                  <div className="pdf-viewer-card">
                    <div className="pdf-viewer-header">
                      <h6>📄 Document / PDF</h6>
                      <div className="pdf-actions">
                        <a href={pdfPreviewUrl} target="_blank" rel="noopener noreferrer">
                          Open in New Tab
                        </a>
                        <a href={pdfPreviewUrl} download>
                          Download PDF
                        </a>
                      </div>
                    </div>
                    <div className="pdf-viewer-body">
                      <iframe
                        src={`${pdfPreviewUrl}#toolbar=1&navpanes=1&scrollbar=1`}
                        title="Blog PDF Document"
                      />
                    </div>
                  </div>
                )}

                <div className="post-content">
                  <p>
                    {/* <strong>Lorem Ipsum</strong> {post.content[0]} */}
                  </p>
                  {/* <p>{post.content[1]}</p> */}
                </div>

                <div className="mt-3">
                  {/* {post.tags.map((t) => (
                    <span key={t} className="tag">
                      {t}
                    </span>
                  ))} */}
                </div>

                <div className="d-flex justify-content-between mt-4 pt-3 border-top">
                  <Link to="/blog" className="text-secondary fw-bold">
                    ← PREVIOUS
                  </Link>
                  <Link to="/blog" className="text-secondary fw-bold">
                    NEXT →
                  </Link>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE — col-3 */}
            {/* RIGHT SIDE — col-3 (replace your existing sidebar block with this) */}
            <div className="col-lg-3 col-md-12">
              {/* AUTHOR BOX */}
              <div className="sidebar-box mb-4">
                <h5 className="fw-bold mb-3">About Author</h5>

                <div className="d-flex align-items-center gap-3">
                  {/* <div className="avatar">GPS</div> */}
                  <div>
                    <strong>GPS Team</strong>
                    <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                      {post.author}
                    </p>
                  </div>
                </div>

                <p
                  className="mt-2 mb-0"
                  style={{ fontSize: "14px", color: "#475569" }}
                >
                  Financial insights, mutual funds & research.
                </p>
              </div>

              {/* COMMENT / ENQUIRY FORM */}
              <div className="sidebar-box mb-4">
                <h5 className="fw-bold mb-3">Leave a Comment</h5>

                {/* Local state for form (ensure useState is imported) */}
                {/* Place these useState declarations at top of your component:
         const [comment, setComment] = useState('');
         const [cname, setCname] = useState('');
         const [cemail, setCemail] = useState('');
         const [cwebsite, setCwebsite] = useState('');
         const [saveInfo, setSaveInfo] = useState(false);
    */}

                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    // Replace this with your actual API call
                    alert("Comment submitted:\n\n" + comment);
                  }}
                >
                  {/* Big textarea */}
                  <div className="mb-3">
                    <textarea
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      className="form-control"
                      rows={8}
                      placeholder="Type here.."
                      required
                      style={{ borderRadius: 6, resize: "vertical" }}
                    />
                  </div>

                  {/* Name / Email / Website inline (row) */}
                  <div className="row g-2 mb-2">
                    <div className="col-12">
                      <input
                        value={cname}
                        onChange={(e) => setCname(e.target.value)}
                        className="form-control"
                        placeholder="Name*"
                        required
                        style={{ borderRadius: 6 }}
                      />
                    </div>
                    <div className="col-12">
                      <input
                        value={cemail}
                        onChange={(e) => setCemail(e.target.value)}
                        className="form-control"
                        placeholder="Email*"
                        type="email"
                        required
                        style={{ borderRadius: 6 }}
                      />
                    </div>
                    <div className="col-12 ">
                      <input
                        value={cwebsite}
                        onChange={(e) => setCwebsite(e.target.value)}
                        className="form-control"
                        placeholder="Website"
                        style={{ borderRadius: 6 }}
                      />
                    </div>
                  </div>

                  {/* Save info checkbox */}
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="saveCommentInfo"
                      checked={saveInfo}
                      onChange={(e) => setSaveInfo(e.target.checked)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="saveCommentInfo"
                      style={{ fontSize: 14 }}
                    >
                      Save my name, email, and website in this browser for the
                      next time I comment.
                    </label>
                  </div>

                  {/* Post comment button */}
                  <div>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{
                        background: "linear-gradient(90deg,#0d6efd,#06b6a4)",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: 8,
                        fontWeight: 700,
                      }}
                    >
                      Post Comment
                    </button>
                  </div>
                </form>
              </div>

              {/* SEARCH BOX (keeps existing search widget) */}
              <div className="sidebar-box">
                <h5 className="fw-bold mb-3">Search</h5>

                <div className="d-flex">
                  <input className="form-control" placeholder="Search..." />
                  <button
                    className="btn btn-send"
                    style={{ width: "90px", marginLeft: "8px" }}
                  >
                    Go
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
